module.exports = __webpack_public_path__ + "img/banner_tab2.59e1de7c.png";